import { useIntlMessages } from '@kokolingo/localisation';

export default useIntlMessages;
